<template>
  <div
    v-if="!userInfo.isAdmin"
    class="video-height"
    :style="{
      height: videoHeight && appointment.videoFlag === 1 ? practicalVideoHeight : '0px',
    }"
  ></div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useStorage } from "@vueuse/core"
const userInfo = useStorage("userinfo", {})
const appointment = useStorage("appointment", {})

// 上课期间-视频窗口开启关闭-控制界面内单词列表顶部是否增高
const videoHeight = useStorage("videoHeight", true, sessionStorage)

// 获取视频高度
const videoOrientation = useStorage("videoOrientation", {}, sessionStorage)

// 计算属性：视频高度
const practicalVideoHeight = computed(() => {
  return videoOrientation.value.height === "9rem" ? "7rem" : "3rem"
})
</script>

<style scoped>
.video-height {
  width: 100%;
}
</style>
